export default __webpack_public_path__ + "c1af369b55d8b26d84fba4fc9185312d.png";